import { QueryClient } from "@tanstack/react-query";
import { onRequestReadReset, requestScope, SupersededRequest } from "./scope.js";

/** Imperative domain reads use this same client as React's provider. Mutations are never retried. */
export const queryClient = new QueryClient({ defaultOptions: {
  queries: { staleTime: 0, gcTime: 30_000, networkMode: "always", retry: (count, error) => count < 1 && !(error instanceof SupersededRequest) && (!("status" in error) || Number(error.status) >= 500) },
  mutations: { retry: false },
} });

export function queryKey(path: string) {
  const scope = requestScope();
  return ["server", scope.generation, scope.accountId ?? "bootstrap", path] as const;
}
export function invalidateServerQueries(): void {
  void queryClient.cancelQueries({ queryKey: ["server"] });
  void queryClient.invalidateQueries({ queryKey: ["server"], refetchType: "none" });
}
onRequestReadReset(() => { void queryClient.cancelQueries(); queryClient.clear(); });
